import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from '@/modules/homepage';

const elements = [
  {
    Component: HomePage,
    path: '/'
  }
];

export const RouterProvider = () => {
  return (
    <BrowserRouter>
      <Routes>
        {elements.map(({ Component, path }, idx) => (
          <Route
            key={idx}
            element={
              <React.Suspense fallback={null}>
                <Component />
              </React.Suspense>
            }
            path={path}
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
};
